<template>
    <section>
        <!-- Modal -->
        <div class="modal fade" id="new_customer_addresses_modal" data-backdrop="static" role="dialog" aria-labelledby="myModalLabel">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        <h4 class="modal-title" id="myModalLabel">Branches of Rider: {{riderName}}</h4>
                    </div>
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-md-12">
                          <div class="btn-group open pull-right">
                            <div data-toggle="dropdown" v-bind:class="'btn btn-primary btn-xs dropdown-toggle ld-ext-right'" aria-expanded="true">
                              Actions
                              <span class="caret"></span>
                              <div class="ld ld-ring ld-spin"></div>
                            </div>
                            <ul class="dropdown-menu">
                              <li><a @click="addBranchToRider()">Assign New Branch</a></li>
                            </ul>
                          </div>
                        </div>
                      </div>
                        <ul class="list-unstyled">
                          <li v-if="riderBranches.length===0">
                            <address>
                              <strong>No branch is assign to this rider </strong>
                            </address>
                          </li>
                            <li v-for="branch in riderBranches" v-bind:key="branch.id">
                              <address>
                                <strong>Name : </strong> {{branch.areasByAreaId.name}} -&nbsp;
                                <a title="Remove Branch" @click="removeBranch(branch.id)"> <i class="fa fa-trash"></i></a>&nbsp;<br>
                                <i>{{branch.restaurantsByRestaurantId.name}}</i>&nbsp;
                              </address>
                            </li>
                        </ul>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    /* eslint-disable */
    import {getAllRiderBranches, removeBranchFromRider} from "@/api/riders";
    import ViewAddUpdateRiderBranches from '@/components/riders/ViewAddUpdateRiderBranches'
    import AddUpdateRider from "@/components/riders/AddUpdateRider.vue";

    export default {
      name: "ViewAddUpdateRiderBranches",
      components: {
        AddUpdateRider
      },
      props: {
      },
      data: function () {
        return {
          riderId: 0,
          riderName: "",
          riderBranches: [],
        };
      },
      methods: {
        load: async function (id, name) {
          this.riderName = name
          this.riderId = parseInt(id);
          await this.loadRiderBranches(parseInt(id));
        },
        loadModal () {
          setTimeout(()=> {
            $("#new_customer_addresses_modal").modal("show");
          },500);
        },
        async loadRiderBranches (riderId) {
          let formData = new FormData();
          formData.append('rider_id', riderId);
          const resp = await getAllRiderBranches(formData);
          this.riderBranches = resp.data.body
          this.loadModal()
        },
        async removeBranch(branchId) {
          let deleteBranch = await this.confirmFromUserBeforeDeleting('Are you sure you want to remove this branch?')
          if (deleteBranch.value) {
            let formData = new FormData();
            formData.append('rider_id', this.riderId);
            formData.append('branch_id', branchId);
            try {
              await removeBranchFromRider(formData);
              swal("SUCCESS!", "Branch has been removed successfully!", "success");
              await this.loadRiderBranches(this.riderId);
              if (this.riderBranches.length===0) {
                await this.$parent.redrawtable();
              }
            } catch (ex) {
              this.showErrorMessage(ex)
            }
          }
        },
        addBranchToRider() {
          this.$parent.$refs.addUpdateRiderPopUp.load(this.riderId, true)
        },
      }
    }
</script>

<style scoped>
.modal { overflow: auto !important; }

</style>
